import { PersonType } from '@api';
import { DotNotationPaths, getValueByPath, useFormatAddress } from '@common';
import { formatBirthdate } from './helpers';

type UseGetRowValuesReturnType = {
  getRowValues: (accessor: DotNotationPaths<PersonType>) => string | null;
};

type UseGetRowValuesPropsType = {
  personDetails: PersonType;
};

export const useGetRowValues = ({
  personDetails,
}: UseGetRowValuesPropsType): UseGetRowValuesReturnType => {
  const { formatAddressMultiLine } = useFormatAddress();

  const getRowValues = (accessor: DotNotationPaths<PersonType>) => {
    const value = (() => {
      switch (accessor) {
        case 'birthdate':
          return formatBirthdate(personDetails.birthdate);
        case 'address':
          return formatAddressMultiLine(personDetails.address);
        default:
          return getValueByPath(personDetails, accessor);
      }
    })();

    return value ? String(value) : null;
  };

  return {
    getRowValues,
  };
};
